angular.module('bmsApp.trugreen.quote').controller('TGQuoteTreatmentModalCtrl', function ($scope,
																					  $modalInstance,
																					  $q,
																					  $ngBootbox,
																					  $filter,
																					  $timeout,
																					  ConfigService,
																					  TaxHelperSvc,
																					  TGTreatmentSvc,
																					  tgJob,
																					  tgJobTreatment) {

	$scope.TGQuoteTreatmentModalCtrl = {
		loading: true,
		processing: false,
		submitted: false,
		vatRate: undefined,
		jobTreatment: null,
		protos: {
			jobTreatment: function () {
				return {
					lawn_size_m2: tgJob.lawn_total_size,
					lawn_front: false,
					lawn_rear: false,
					lawn_side: false,
					lawn_other: false,
					lawn_all: true,
					lawn_front_size: tgJob.lawn_front_size,
					lawn_rear_size: tgJob.lawn_rear_size,
					lawn_side_size: tgJob.lawn_side_size,
					lawn_other_size: tgJob.lawn_other_size,
					is_custom_price: false,
					selling_price_per_treatment_vat_applied: $scope.TGQuoteTreatmentModalCtrl.vatRate,
					treatments_per_year: 1,
					products: [
						$scope.TGQuoteTreatmentModalCtrl.protos.jobTreatmentProduct()
					]
				};
			},
			jobTreatmentProduct: function () {
				return {};
			}
		},
		options: {},
		methods: {
			init: function () {
				$scope.config = ConfigService.config;
				$scope.jobTreatmentOriginal = angular.copy(tgJobTreatment);
				$scope.TGQuoteTreatmentModalCtrl.methods.populateFormOptions()
					.then(function () {
						$scope.TGQuoteTreatmentModalCtrl.jobTreatment = $scope.TGQuoteTreatmentModalCtrl.protos.jobTreatment();
						if (angular.isObject(tgJobTreatment)) {
							angular.extend($scope.TGQuoteTreatmentModalCtrl.jobTreatment, tgJobTreatment);
						}

						// if the treatment changes (including when first loaded) we need to set the new product options
						$scope.$watchGroup([
							'TGQuoteTreatmentModalCtrl.jobTreatment.treatment_attr',
							'TGQuoteTreatmentModalCtrl.options.treatment'
						], function () {
							var treatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment.treatment_attr;
							var treatmentOptions = $scope.TGQuoteTreatmentModalCtrl.options.treatment;
							if (angular.isObject(treatment) && angular.isArray(treatmentOptions)) {
								// find this treatment in the options list
								var treatmentOptionResult = $filter('filter')(treatmentOptions, {id: treatment.id}, true);
								if (angular.isArray(treatmentOptionResult) && treatmentOptionResult.length) {
									// set product options to this treatment's product options
									$scope.TGQuoteTreatmentModalCtrl.options.product = treatmentOptionResult[0].products_list;
								}
								else {
									console.error('Selected treatment not found in options');
								}
							}
						});

						// if any of the lawn sizes change we need to update the total applied lawn size
						$scope.$watchGroup([
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_front',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_rear',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_side',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_other',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_all',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_front_size',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_rear_size',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_side_size',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_other_size'
						], function () {
							// this will update the lawn_size_m2 which is being watched below
							$scope.TGQuoteTreatmentModalCtrl.methods.calculateLawnSize();
						});

						// if the treatment or the applied lawn size changes we need to set the new price
						$scope.$watchGroup([
							'TGQuoteTreatmentModalCtrl.jobTreatment.treatment_attr',
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_size_m2'
						], function (newValues, oldValues) {
							var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
							if (angular.isObject(jobTreatment.treatment_attr)) {
								$scope.TGQuoteTreatmentModalCtrl.processing = true;
								var treatmentId = jobTreatment.treatment_attr.id;
								var lawnArea = jobTreatment.lawn_size_m2;
								var customerId = angular.isObject(tgJob.customer) ? tgJob.customer.id : null;
								TGTreatmentSvc.getTreatmentPrice(treatmentId, lawnArea, customerId)
									.then(function (response) {


										if (response.data.treatment_price.customer_treatment_price) {
											angular.extend(jobTreatment, {
												is_custom_price: true,
												selling_price_per_treatment_net: response.data.treatment_price.customer_treatment_price,
												selling_price_per_treatment_gross: TaxHelperSvc.grossFromNet(response.data.treatment_price.customer_treatment_price),
												annual_treatment_price_net: response.data.treatment_price.customer_treatment_price * jobTreatment.treatments_per_year,
												annual_treatment_price_gross: TaxHelperSvc.grossFromNet(response.data.treatment_price.customer_treatment_price) * jobTreatment.treatments_per_year,
												treatment_time_in_mins: response.data.treatment_price.treatment_time_in_mins
											});
										}
										else {
											angular.extend(jobTreatment, {
												is_custom_price: false
											});
										}

										// Always save the customer treatment price so we can switch back and forth
										angular.extend(jobTreatment, {
											customer_selling_price_net: response.data.treatment_price.customer_treatment_price
										});

										var tmp_treatment_price;
										tmp_treatment_price = $scope.TGQuoteTreatmentModalCtrl.treatment_price = response.data.treatment_price;

										if(tgJob.copied && $scope.jobTreatmentOriginal && $scope.jobTreatmentOriginal.treatment_attr.id == jobTreatment.treatment_attr.id){
											$timeout(function () {
												$scope.$apply(function () {
													angular.extend(jobTreatment, {
														selling_price_per_treatment_net: $scope.jobTreatmentOriginal.selling_price_per_treatment_net,
														selling_price_per_treatment_gross: $scope.jobTreatmentOriginal.selling_price_per_treatment_gross,
														selling_price_per_treatment_vat: $scope.jobTreatmentOriginal.selling_price_per_treatment_vat,
														annual_treatment_price_net: $scope.jobTreatmentOriginal.selling_price_per_treatment_net * jobTreatment.treatments_per_year,
														annual_treatment_price_gross: $scope.jobTreatmentOriginal.selling_price_per_treatment_gross * jobTreatment.treatments_per_year,
														treatment_time_in_mins: $scope.jobTreatmentOriginal.treatment_time_in_mins
													});
												});
											});

											$scope.TGQuoteTreatmentModalCtrl.processing = false;
											return;
										}
										// only set treatment price if not custom
										if (jobTreatment.is_custom_price !== true ) {
											$timeout(function () {
												$scope.$apply(function () {
													angular.extend(jobTreatment, {
														selling_price_per_treatment_net: tmp_treatment_price.treatment_rrp_net,
														selling_price_per_treatment_gross: tmp_treatment_price.treatment_rrp_gross,
														selling_price_per_treatment_vat: tmp_treatment_price.treatment_rrp_vat,
														annual_treatment_price_net: tmp_treatment_price.treatment_rrp_net * jobTreatment.treatments_per_year,
														annual_treatment_price_gross: tmp_treatment_price.treatment_rrp_gross * jobTreatment.treatments_per_year,
														treatment_time_in_mins: tmp_treatment_price.treatment_time_in_mins
													});

												});
											});
										}
										$scope.TGQuoteTreatmentModalCtrl.processing = false;
									});
								$scope.TGQuoteTreatmentModalCtrl.methods.calculateProductCosts();
							}
							else {
								$scope.TGQuoteTreatmentModalCtrl.treatment_price = null;
							}
						});

						// if the selling price or treatments per year changes update the cost per annum
						$scope.$watchGroup([
							'TGQuoteTreatmentModalCtrl.jobTreatment.selling_price_per_treatment_net',
							'TGQuoteTreatmentModalCtrl.jobTreatment.treatments_per_year'
						], function () {
							var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
							jobTreatment.annual_treatment_price_net = parseFloat(jobTreatment.selling_price_per_treatment_net) * parseInt(jobTreatment.treatments_per_year);
							jobTreatment.annual_treatment_price_gross = parseFloat(jobTreatment.selling_price_per_treatment_gross) * parseInt(jobTreatment.treatments_per_year);
						});

						// watch lawn size, treatments per year, cost per annum and all the products to see if the product costs and percentages have changed
						$scope.$watchGroup([
							'TGQuoteTreatmentModalCtrl.jobTreatment.lawn_size_m2',
							'TGQuoteTreatmentModalCtrl.jobTreatment.treatments_per_year',
							'TGQuoteTreatmentModalCtrl.jobTreatment.annual_treatment_price_net'
						], function () {
							$scope.TGQuoteTreatmentModalCtrl.methods.calculateProductCosts();
						});

						$scope.$watch('TGQuoteTreatmentModalCtrl.jobTreatment.products', function () {
							$scope.TGQuoteTreatmentModalCtrl.methods.calculateProductCosts();
						}, true);
					});
			},
			populateFormOptions: function () {
				var promises = {
					vatRate: TaxHelperSvc.getVatRate()
						.then(function (vatRate) {
							$scope.TGQuoteTreatmentModalCtrl.vatRate = vatRate;
						}),
					treatmentOptions: TGTreatmentSvc.options()
				};
				return $q.all(promises)
					.then(function (responses) {
						$scope.TGQuoteTreatmentModalCtrl.options.treatment = responses.treatmentOptions.data.options;
						$scope.TGQuoteTreatmentModalCtrl.loading = false;
					});
			},
			addJobTreatmentProduct: function () {
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				jobTreatment.products.push($scope.TGQuoteTreatmentModalCtrl.protos.jobTreatmentProduct());
			},
			removeJobTreatmentProduct: function (jobTreatmentProduct) {
				angular.extend(jobTreatmentProduct, {
					delete: true
				});
			},
			calculateLawnSize: function () {
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				var total = 0;
				// if it's the whole lawn the parts lawn parts fields should be reset
				if (jobTreatment.lawn_all === true) {
					jobTreatment.lawn_front = jobTreatment.lawn_rear = jobTreatment.lawn_side = jobTreatment.lawn_other = false;
					jobTreatment.lawn_front_size = tgJob.lawn_front_size;
					jobTreatment.lawn_rear_size = tgJob.lawn_rear_size;
					jobTreatment.lawn_side_size = tgJob.lawn_side_size;
					jobTreatment.lawn_other_size = tgJob.lawn_other_size;
				}

				if (jobTreatment.lawn_all === true || jobTreatment.lawn_front === true) {
					total += parseInt(jobTreatment.lawn_front_size);
				}
				if (jobTreatment.lawn_all === true || jobTreatment.lawn_rear === true) {
					total += parseInt(jobTreatment.lawn_rear_size);
				}
				if (jobTreatment.lawn_all === true || jobTreatment.lawn_side === true) {
					total += parseInt(jobTreatment.lawn_side_size);
				}
				if (jobTreatment.lawn_all === true || jobTreatment.lawn_other === true) {
					total += parseInt(jobTreatment.lawn_other_size);
				}
				jobTreatment.lawn_size_m2 = total;
			},
			calculateProductCosts: function () {
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				if (angular.isObject(jobTreatment.treatment_attr) && $scope.TGQuoteTreatmentModalCtrl.isCalculatingProductCosts !== true) {
					// prevent method from triggering itself again when it update products
					$scope.TGQuoteTreatmentModalCtrl.isCalculatingProductCosts = true;

					angular.forEach(jobTreatment.products, function (jobTreatmentProduct) {

						var productCost, productCostPercent;
						if (angular.isObject(jobTreatmentProduct.product_attr)) {
							productCost = parseFloat(jobTreatmentProduct.product_attr.cost_per_m2) * parseInt(jobTreatment.lawn_size_m2) * parseInt(jobTreatment.treatments_per_year);
							if (jobTreatment.annual_treatment_price_net >= 0.01) {
								// this should probably be based on gross, sticking with how BMS1 works for now
								productCostPercent = productCost / jobTreatment.annual_treatment_price_net * 100;
								// round 2 dp
								productCostPercent = Math.round(productCostPercent * 100) / 100;
							}
							else {
								productCostPercent = 100;
							}
						}
						else {
							productCost = null;
							productCostPercent = null;
						}
						angular.extend(jobTreatmentProduct, {
							product_cost: productCost,
							product_cost_percent: productCostPercent
						});
					});
					$scope.TGQuoteTreatmentModalCtrl.isCalculatingProductCosts = false;
				}
			},
			cancel: function () {
				$ngBootbox.confirm('Are you sure you want to do this?')
					.then(function () {
						$modalInstance.dismiss('cancel');
					});
			}
		},
		eventHandlers: {
			onTreatmentChange: function () {
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				// mark all products for deletion
				angular.forEach(jobTreatment.products, function (product) {
					angular.extend(product, {
						delete: true
					});
				});
				if (angular.isObject(jobTreatment.treatment_attr) && jobTreatment.treatment_attr.treatment_type_string == 'chemical') {
					// add a new empty product
					jobTreatment.products.push($scope.TGQuoteTreatmentModalCtrl.protos.jobTreatmentProduct());
				}
			},
			onLawnSectionApplyChange: function (section, value) {
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				switch(section) {
					case 'front':
						jobTreatment.lawn_front_size = value === true ? tgJob.lawn_front_size : jobTreatment.lawn_front_size;
						break;
					case 'rear':
						jobTreatment.lawn_rear_size = value === true ? tgJob.lawn_rear_size : jobTreatment.lawn_rear_size;
						break;
					case 'side':
						jobTreatment.lawn_side_size = value === true ? tgJob.lawn_side_size : jobTreatment.lawn_side_size;
						break;
					case 'other':
						jobTreatment.lawn_other_size = value === true ? tgJob.lawn_other_size : jobTreatment.lawn_other_size;
						break;
				}
			},
			onLawnSectionSizeChange: function (section, value) {
				var tmpValue = parseInt(value);
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				// make sure it's a positive number
				tmpValue = isNaN(tmpValue) ? 0 : tmpValue;
				tmpValue = tmpValue < 0 ? 0 : tmpValue;
				// make sure it's less than or equal to corresponding lawn portion
				switch(section) {
					case 'front':
						tmpValue = tmpValue > parseInt(tgJob.lawn_front_size) ? parseInt(tgJob.lawn_front_size) : tmpValue;
						jobTreatment.lawn_front_size = tmpValue;
						break;
					case 'rear':
						tmpValue = tmpValue > parseInt(tgJob.lawn_rear_size) ? parseInt(tgJob.lawn_rear_size) : tmpValue;
						jobTreatment.lawn_rear_size = tmpValue;
						break;
					case 'side':
						tmpValue = tmpValue > parseInt(tgJob.lawn_side_size) ? parseInt(tgJob.lawn_side_size) : tmpValue;
						jobTreatment.lawn_side_size = tmpValue;
						break;
					case 'other':
						tmpValue = tmpValue > parseInt(tgJob.lawn_other_size) ? parseInt(tgJob.lawn_other_size) : tmpValue;
						jobTreatment.lawn_other_size = tmpValue;
						break;
				}
			},
			onIsCustomPriceChange: function () {
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				var treatment_price = $scope.TGQuoteTreatmentModalCtrl.treatment_price;
				if (jobTreatment.is_custom_price !== true && angular.isObject(treatment_price)) {
					// reset the price, gross is being watched so that cost per annum will be updated
					angular.extend(jobTreatment, {
						selling_price_per_treatment_net: treatment_price.treatment_rrp_net,
						selling_price_per_treatment_vat: treatment_price.treatment_rrp_vat,
						selling_price_per_treatment_gross: treatment_price.treatment_rrp_gross
					});
				}
				else {
					angular.extend(jobTreatment, {
						selling_price_per_treatment_net: jobTreatment.customer_selling_price_net,
						selling_price_per_treatment_gross: TaxHelperSvc.grossFromNet(jobTreatment.customer_selling_price_net)
					});
				}
			},
			onSellingPriceNetChange: function () {
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				jobTreatment.selling_price_per_treatment_vat = TaxHelperSvc.vatFromNet(jobTreatment.selling_price_per_treatment_net);
				jobTreatment.selling_price_per_treatment_gross = TaxHelperSvc.grossFromNet(jobTreatment.selling_price_per_treatment_net);
			},
			onSellingPriceGrossChange: function () {
				var jobTreatment = $scope.TGQuoteTreatmentModalCtrl.jobTreatment;
				jobTreatment.selling_price_per_treatment_net = TaxHelperSvc.netFromGross(jobTreatment.selling_price_per_treatment_gross);
				jobTreatment.selling_price_per_treatment_vat = TaxHelperSvc.vatFromGross(jobTreatment.selling_price_per_treatment_gross);
			}
		},
		formvalidatorconfig: {
			submitHandler: function () {
				$scope.TGQuoteTreatmentModalCtrl.submitted = true;
				modalResult = {
					jobTreatment: $scope.TGQuoteTreatmentModalCtrl.jobTreatment
				};

				$modalInstance.close(modalResult);
			},
			errorPlacement: function (error) {
				error.appendTo('#tg-job-treatment-errors');
			},
			errorContainer: '#tg-job-treatment-errors'
		}
	};

	$scope.TGQuoteTreatmentModalCtrl.methods.init();

});
